import declare from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import HintBox from 'more/HintBox';
import template from './Item.html?raw';
export default declare("WidgetCollection.Occurrence.List.Item", [_WidgetBaseSP], {
        templateString: template,

        entityID: null,
        jsonData: null,
        listContainer: null,

        postMixInProperties: function () {
            this.inherited(arguments);
        },
        postCreate: function () {
            this.inherited(arguments);
            this.RequestManager.silentExceptions = true;
        },

        startup: function (bReload) {
            if (this.jsonData == null || bReload === true) {
                this.loadOccurrence();
            }

            else {
                this.drawItem();
            }            
        },

        loadOccurrence: function (entityID) {

            this.StandbyStart();

            var url = window.appRoot + "Occurrence/LoadOccurrencJSON";

            if (entityID != null && typeof (entityID) != "undefined") {
                this.entityID = entityID;
            }

            var occurrenceID = this.entityID;

            this.RequestManager.post(
                url,
                {
                    occurrenceID: occurrenceID, // jsonData falls mal nötig
                },
                lang.hitch(this, "_onLoadOccurrenceResponse"),
                lang.hitch(this, "_onLoadOccurrenceError"),
                false // sync
            );
        },

        _onLoadOccurrenceResponse: function (response) {
            this.StandbyStop();
            this.jsonData = JSON.parse(response);

            this.drawItem();            
        },

        _onLoadOccurrenceError: function (error) {
            this.StandbyStop();
        },

        drawItem: function () {
            if (this.jsonData == null) {
                return;
            }
        }
        
    });
